import styles from './CaseStudyLarge.module.scss'
import TitleBlock from 'components/services/commons/TitleBlock'
import CaseStudySliderPC, { CaseStudySliderItems } from './PCCaseStudy/PCCaseStudy'
import CaseStudySliderSP from './MobileCaseStudy/MobileCaseStudy'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { useMediaQuery } from '@material-ui/core'

gsap.registerPlugin(ScrollTrigger)

const tweenVars: gsap.TimelineVars = [
  {
    y: '50',
    duration: 1,
    opacity: 0,
    ease: Power4.easeOut,
  },
  {
    x: '-50',
    duration: 0.5,
    opacity: 0,
    ease: Power4.easeOut,
  },
  {
    duration: 1,
    width: '40px',
    border: '1px solid #3C3C3C',
    ease: Power4.easeOut,
  },
]

interface Props {
  caseStudyObject: CaseStudySliderItems
}

const CaseStudyLarge: React.FC<Props> = ({ caseStudyObject }) => {
  const isPC = useMediaQuery('(min-width: 1200px)')

  const timeline = gsap.timeline()

  const trigger = useRef<HTMLDivElement>()
  const slider = useRef<HTMLDivElement>()

  useEffect(() => {
    timeline.from(slider.current, tweenVars[0])

    ScrollTrigger.create({
      animation: timeline,
      trigger: trigger.current,
      start: 'top+=50 80%',
      toggleActions: 'play none none reverse',
    })
  }, [])

  const sectionTitle = {
    title: 'Case study',
    sub_title: '関連事例',
  }

  return (
    <section className={styles.content} ref={trigger}>
      <div className={styles.title_outer}>
        <div className={styles.title_inner}>
          <TitleBlock sectionTitle={sectionTitle} />
        </div>
      </div>
      <div className={styles.slider} ref={slider}>
        {isPC ? (
          <CaseStudySliderPC caseStudySliderList={caseStudyObject} />
        ) : (
          <CaseStudySliderSP caseStudySliderList={caseStudyObject} />
        )}
      </div>
    </section>
  )
}

export default CaseStudyLarge
